import { Condition } from './common';
import { NoteLinkType } from './notes';
import { AccountType, ServiceAreaType } from './product';

export enum FullAvailabilityStatus {
  Available = '',
  RequiresConfirmation = 'Requires Confirmation',
  Unavailable = 'Unavailable',
  Away = 'Away',
  OnSiteJob = 'Onsite Job',
  RemoteJob = 'Remote Job',
  TravelBuffer = 'Travel Buffer',
}

export enum TechnicianType {
  Technician = 'T',
  Consultant = 'C',
  Employee = 'E',
  Franchisee = 'F',
  FTTech = 'G',
}

export enum SkillLevel {
  None = 0,
  Proficient = 1,
  Expert = 2,
}

export enum ServiceTypeAvailability {
  NotAvailable = 0,
  Available = 1,
}

export type TechnicianSkillSet = {
  ID: number;
  technician_ID: number;
  skillset_ID: number;
  level: SkillLevel;
  description: string;
  long_description: string;
};

export type TechnicianServiceType = {
  ID: number;
  technician_ID: number;
  service_type_ID: number;
  service_status: ServiceTypeAvailability;
  type_description: string;
};

export type Suburb = {
  ID: number;
  suburb: string;
  state: string;
  state_ID: number;
  postcode: number;
  lat: string;
  lon: string;
  type_is: string;
};

export type ServiceAreaSuburb = Suburb & {
  technician_ID: number;
  suburb_ID: number;
  primary_secondary: ServiceAreaType;
};

export type ServiceAreaHomeSuburb = Pick<Suburb, 'lat' | 'lon' | 'suburb' | 'state' | 'postcode'>;

export type TechnicianServiceAreaData = {
  suburbs: ServiceAreaSuburb[];
  home: ServiceAreaHomeSuburb | null;
};

export type Technician = {
  ID: number;
  type: AccountType;
  company: string;
  gst_reg: Condition;
  abn: string;
  abn_status: number;
  abn_status_update: string; // ISO datetime string
  contact1_title: string;
  contact1_firstname: string;
  contact1_surname: string;
  contact1_mobile: string;
  contact1_work: string;
  second_contact: Condition;
  contact2_title: string;
  contact2_firstname: string;
  contact2_surname: string;
  contact2_mobile: string;
  contact2_work: string;
  emergency_contact: string;
  emergency_relationship: string;
  emergency_mobile: string;
  physical_address_line1: string;
  physical_address_line2: string;
  physical_suburb: string;
  physical_state: string;
  physical_postcode: string;
  physical_suburb_ID: number;
  same_address: Condition;
  postal_address_line1: string;
  postal_address_line2: string;
  postal_suburb: string;
  postal_state: string;
  postal_postcode: string;
  postal_suburb_ID: number;
  base_suburb_ID: number;
  phone: string;
  fax: string;
  email: string;
  gst: Condition;
  sds_availability: Condition;
  notes: string;
  blacklist: string;
  book_status: number;
  default_availability: Condition;
  travel_buffer: '1.00' | '0.5';
  date_started: string; // YYYY-MM-DD
  date_finished: string; // YYYY-MM-DD
  active: Condition;
  category: 'H' | 'B' | 'A';
  priority: '1' | '2' | '3' | '4' | '5';
  parts_rate_threshold: string;
  labour_fee_business: string;
  labour_fee_soho: string;
  tech_type: TechnicianType;
  status: string;
  daily_sms: Condition;
  smart_travel_buffer: 1 | 0;
  surrounding_areas: 1 | 0;
  availability_sms: Condition;
  uuid: string | null;
  name: string;
  address: {
    full_address: string;
    map_address: string;
    address_line_1: string;
    address_line_2: string;
    suburb: string;
    state: string;
    postcode: string;
  };
  contact: string[];
  mobile: string[];
  attendance_rate: string;
  avg_csi: string;
  overall_score: string;
};

export type NoteLink = {
  ID: number;
  note_ID: number;
  link_ID: number;
  link_type: NoteLinkType;
};

export type TehcnicianNoteLink = {
  link_ID: number;
  link_type: NoteLinkType;
};

export type TechnicianNote = {
  ID: number;
  link_type: string;
  link_ID: number;
  datetime: string; // 'YYYY-MM-DD HH:mm:ss'
  notes: string;
  user_ID: number;
  hqonly: number;
  note_type: number;
  deleted_by: string | null;
  deleted_at: string | null;
  link: NoteLink[];
};
